import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { JsonLdService, MetaService, NotificationsService } from '@app/core';
import { SharedModule } from '@app/shared';
import {
  TuiButton,
  TuiError,
  TuiGroup,
  TuiLabel,
  TuiTextfield,
} from '@taiga-ui/core';
import {
  TuiBadge,
  TuiButtonLoading,
  TuiCheckbox,
  TuiFieldErrorPipe,
} from '@taiga-ui/kit';
import { RoughNotationModule } from 'ng-rough-notation';
import { NewsletterService } from '../../services';

@Component({
  selector: 'app-newsletter',
  imports: [
    RoughNotationModule,
    SharedModule,
    TuiBadge,
    TuiButton,
    TuiButtonLoading,
    TuiCheckbox,
    TuiError,
    TuiFieldErrorPipe,
    TuiGroup,
    TuiLabel,
    TuiTextfield,
  ],
  templateUrl: './newsletter.component.html',
  styleUrl: './newsletter.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsletterComponent {
  protected readonly formGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    terms: new FormControl(false, [Validators.requiredTrue]),
  });
  protected readonly subscribeNewsletter = this.newsletterService.subscribe();

  constructor(
    private readonly metaService: MetaService,
    private readonly newsletterService: NewsletterService,
    private readonly notificationsService: NotificationsService,
    private readonly jsonLdService: JsonLdService,
  ) {
    this.metaService.setDescription(
      [
        'Subscribe to the Capawesome Newsletter for monthly updates on Capawesome, Capacitor, and Ionic.',
        'Stay informed with the latest news!',
      ].join(' '),
    );
    this.metaService.setTitle('Newsletter');
    this.metaService.setKeywords([
      'newsletter',
      'Capacitor updates',
      'Capawesome news',
    ]);
    this.jsonLdService.setStructuredData(
      JsonLdService.buildWebPageSchema(
        'Newsletter - Capawesome Cloud',
        'Subscribe to the Capawesome Newsletter for monthly updates.',
        'https://cloud.capawesome.io/newsletter/',
      ),
    );
  }

  protected async onSubmit(): Promise<void> {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.invalid) {
      return;
    }
    if (!this.formGroup.value.email) {
      return;
    }
    await this.subscribeNewsletter.mutateAsync({
      email: this.formGroup.value.email,
    });
    void this.notificationsService.showSuccessNotification(
      'You have successfully subscribed to the newsletter!',
    );
    this.formGroup.reset({
      email: '',
      terms: false,
    });
  }
}
